import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

/* ================= DATA ================= */
const DEFAULT_MIND_MINING_GAMES = [
  { id: 1, title: "Puzzle Master", image: "/assets/gamescard/puzzle-master.png", link: "http://ghanagameium.com/jigsaw-puzzle/" },
  { id: 2, title: "Genius", image: "/assets/gamescard/genius.png", link: "http://ghanagameium.com/genius/" },
  { id: 3, title: "Sudoku", image: "/assets/gamescard/sudoku.png", link: "http://ghanagameium.com/sudoku/" },
  { id: 4, title: "Slider Puzzle", image: "/assets/gamescard/sliderpuzzle.png", link: "http://ghanagameium.com/slider-puzzle/" },
  { id: 5, title: "Spelling Challenge", image: "/assets/gamescard/spellingchllange.png", link: "http://ghanagameium.com/spelling-challenge/" },
  { id: 6, title: "3D Maze", image: "/assets/gamescard/3dmaze.png", link: "http://ghanagameium.com/3dmaze/" },
  { id: 7, title: "Neon Pong", image: "/assets/gamescard/neonpong.png", link: "http://ghanagameium.com/ai-puzzle/" },
  { id: 8, title: "Connect Four", image: "/assets/gamescard/connectfour.png", link: "http://ghanagameium.com/connect-four-classic/" },
  { id: 9, title: "Archery Master", image: "/assets/gamescard/shooting.png", link: "http://ghanagameium.com/shooting-game/" },
  { id: 10, title: "Water Sort", image: "/assets/gamescard/watersort.png", link: "http://ghanagameium.com/water-sort-puzzle/" },
  { id: 11, title: "Color Spinner", image: "/assets/gamescard/color-spinner.png", link: "http://ghanagameium.com/color-spinner/" },
  { id: 12, title: "Juicy Puzzle", image: "/assets/gamescard/juicy-puzzle.png", link: "http://ghanagameium.com/juicy-puzzle/" },
  { id: 13, title: "Tetris Evolution", image: "/assets/gamescard/tetris-evolution.png", link: "http://ghanagameium.com/tetris-evolution/" },
  { id: 14, title: "Word Puzzle", image: "/assets/gamescard/word-puzzle.png", link: "http://ghanagameium.com/word-puzzle.jpg/" },
  { id: 15, title: "Guess The Quiz", image: "/assets/gamescard/guessquiz.png", link: "http://ghanagameium.com/engaging-emoji/" },
];

const MindMining = () => {
  const navigate = useNavigate();

const handleGameClick = (game) => {
  const isSubscribed = localStorage.getItem("isSubscribed") === "true";

  if (!isSubscribed) {
    Swal.fire({
      title: "🚫 Subscription Required",
      text: "Please subscribe to play games",
      icon: "warning",
      confirmButtonColor: "#ff003c",
      confirmButtonText: "Go to Subscribe",
    }).then((result) => {
      if (result.isConfirmed) {
        navigate("/signin");
      }
    });
    return;
  }

  if (game.link) {
    window.open(game.link, "_self");
  } else {
    navigate("/games");
  }
};

  return (
    <div className="relative overflow-hidden mt-5">

      {/* 🔥 LIGHT GLOW BACKGROUND */}
      <div className="absolute left-[-180px] top-[20px] w-[350px] h-[350px] rounded-full 
      bg-gradient-to-br from-[#ff003c] to-[#6a00ff] 
      opacity-10 blur-[100px] pointer-events-none"></div>

      <div className="absolute right-[-150px] bottom-[0px] w-[300px] h-[300px] rounded-full 
      bg-gradient-to-tr from-[#ff003c] to-[#6a00ff] 
      opacity-10 blur-[120px] pointer-events-none"></div>

      {/* CONTENT */}
      <div className="relative z-10 w-full py-10 px-4">
        <div className="max-w-6xl mx-auto">

          {/* HEADER */}
          <div className="flex flex-wrap justify-between items-center mb-8 gap-4">
            <h2 className="text-white text-3xl font-bold">
              <span className="text-[#ff003c]">Mind</span> Mining
            </h2>

            <div className="flex items-center gap-3">

              {/* VIEW ALL */}
              <button
                onClick={() => navigate("/games")}
                className="px-5 py-2 rounded-lg text-white font-semibold 
                bg-gradient-to-r from-[#ff003c] to-[#6a00ff]
                hover:scale-105 transition-all duration-300"
              >
                View All
              </button>

              {/* ARROWS */}
              <button className="swiper-button-prev-mind w-10 h-10 rounded-lg flex items-center justify-center 
              bg-[#1f1f35] hover:bg-[#ff003c] transition-all duration-300">
                <IoIosArrowBack className="text-white" />
              </button>

              <button className="swiper-button-next-mind w-10 h-10 rounded-lg flex items-center justify-center 
              bg-[#1f1f35] hover:bg-[#ff003c] transition-all duration-300">
                <IoIosArrowForward className="text-white" />
              </button>

            </div>
          </div>

          {/* SLIDER */}
          <Swiper
            modules={[Navigation, Autoplay]}
            navigation={{
              prevEl: ".swiper-button-prev-mind",
              nextEl: ".swiper-button-next-mind",
            }}
            autoplay={{ delay: 3500, disableOnInteraction: false }}
            loop
            spaceBetween={20}
            breakpoints={{
              0: { slidesPerView: 2 },
              640: { slidesPerView: 3 },
              1024: { slidesPerView: 4 },
              1280: { slidesPerView: 5 },
            }}
          >
            {DEFAULT_MIND_MINING_GAMES.map((game) => (
              <SwiperSlide key={game.id}>
                <div
                  className="group cursor-pointer flex flex-col h-full"
                  onClick={() => handleGameClick(game)}
                >

                  {/* CARD */}
                  <div className="rounded-xl border border-[#ff003c]/20 
                  bg-[#141422] overflow-hidden
                  shadow-[0_10px_20px_rgba(255,0,60,0.1)]
                  hover:border-[#ff003c] 
                  hover:shadow-[0_0_20px_rgba(255,0,60,0.4)]
                  transition-all duration-300">

                    {/* IMAGE FIX 🔥 */}
                    <div className="w-full h-[160px] sm:h-[200px] md:h-[220px] overflow-hidden">
                      <img
                        src={game.image}
                        alt={game.title}
                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                      />
                    </div>
                  </div>

                  {/* TITLE */}
                  <h3 className="text-white text-sm sm:text-base md:text-lg font-semibold mt-4 text-center group-hover:text-[#ff003c] transition">
                    {game.title}
                  </h3>

                </div>
              </SwiperSlide>
            ))}
          </Swiper>

        </div>
      </div>
    </div>
  );
};

export default MindMining;